import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { UpdateParticipantWidgetLayoutItems } from '../mutations/updateParticipantWidgetLayoutItems.mutation';
import type {
  UpdateParticipantWidgetLayoutItemsMutation,
  UpdateParticipantWidgetLayoutItemsMutationVariables,
} from '../types';

export const useUpdateParticipantWidgetLayoutItemsMutation = (
  options?: MutationOptions<
    UpdateParticipantWidgetLayoutItemsMutation,
    UpdateParticipantWidgetLayoutItemsMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateParticipantWidgetLayoutItems), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('widgets'),
      });
    },
  });
};
